<template>
  <div>
    <WyneLoverTopNav active-app="atlas" />
    <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
      <AtlasMobile v-if="matches" />
      <AtlasDesktop v-else />
    </MatchMedia>
  </div>
</template>

<script>
import { MatchMedia } from "vue-component-media-queries";
import Cookies from "js-cookie";

import WyneLoverTopNav from '@/components/WyneLover_TopNav.vue';

import AtlasMobile from "@/components/Atlas_Mobile.vue";
import AtlasDesktop from "@/components/Atlas_Desktop.vue";

export default {
  name: "Atlas",

  components: {
    WyneLoverTopNav,

    MatchMedia,
    AtlasMobile,
    AtlasDesktop
  },

  created() {
    const supportedLanguages = [
      "en", "fr", "de", "es", "it", "nl", "pt"
    ];

    let language = Cookies.get("wynelover.language");

    if (!supportedLanguages.includes(language)) {
      language = "en";
    }

    this.$store.commit("setLanguage", language);
  }
};
</script>